import * as React from 'react';
import Tooltip from '@mui/material/Tooltip';
import CloseIcon from '@mui/icons-material/Close';

type Role = { id?: string | number; label: string; default?: boolean };

export default function SpeakerRoles({
  speakerRoles,
  changeDefaultRole,
  deleteRole,
}: {
  speakerRoles: Role[];
  changeDefaultRole: (i: number) => void;
  deleteRole: (e: React.MouseEvent, i: number) => void;
}) {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);
  const parentRefs = React.useRef<(HTMLButtonElement | null)[]>([]);

  const openParent = (i: number) => setOpenIndex(i);
  const closeParent = () => setOpenIndex(null);

  // If we leave the child and the next target is still inside the parent, re-open the parent tooltip
  const maybeReopenParent = (i: number, e: React.MouseEvent | React.FocusEvent) => {
    const next = e.relatedTarget as Node | null;
    if (next && parentRefs.current[i]?.contains(next)) setOpenIndex(i);
  };

  return (
    <div id="speaker_roles_container">
      {speakerRoles.map((iterationRole, index) => {
        const isDefault = !!iterationRole.default;
        return (
          <Tooltip
            arrow
            key={iterationRole.id ?? index}
            title={`Nastavi ${iterationRole.label} kot privzeto`}
            open={openIndex === index && !iterationRole.default}
            disableHoverListener
            disableFocusListener
            disableTouchListener
            disableInteractive
          >
            <button
              type="button"
              ref={(el) => (parentRefs.current[index] = el)}
              onClick={() => changeDefaultRole(index)}
              className={`speaker_role${isDefault ? ' speaker_role_default' : ''}`}
              onMouseEnter={() => openParent(index)}
              onMouseLeave={closeParent}
              onFocus={() => openParent(index)}
              onBlur={closeParent}
            >
              <Tooltip arrow title="Odstrani vlogo" disableInteractive>
                <button
                  type="button"
                  onClick={(event) => {
                    event.stopPropagation();
                    deleteRole(event, index);
                  }}
                  className="speaker_role_delete"
                  onMouseEnter={closeParent}
                  onMouseLeave={(e) => maybeReopenParent(index, e)}
                  onFocus={closeParent}
                  onBlur={(e) => maybeReopenParent(index, e)}
                  aria-label={`Delete ${iterationRole.label}`}
                >
                  <div
                    className={`speaker_role_delete_container${
                      isDefault ? ' speaker_role_delete_container_default' : ''
                    }`}
                  >
                    <CloseIcon sx={{ color: isDefault ? '#2b8dff' : '#F2F2F2', width: 18, height: 18 }} />
                  </div>
                </button>
              </Tooltip>

              <p>{iterationRole.label}</p>
            </button>
          </Tooltip>
        );
      })}
    </div>
  );
}
